import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { ViewCardsComponent } from './cards/view-cards/view-cards/view-cards.component';

@Injectable()
export class ConfirmDeactivateGuard implements CanDeactivate<ViewCardsComponent> {

  canDeactivate(viewCardsComponent: ViewCardsComponent): Observable<boolean> | boolean {
    if (viewCardsComponent.hasChanges) {
      return viewCardsComponent.sureYouWantToClose().first();
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/candeactivate.guard.ts